import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "area-select" }
const _hoisted_2 = { class: "area-select-row" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "area-warning",
  role: "alert"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "area-warning"
}
const _hoisted_9 = {
  key: 2,
  class: "area-warning"
}

import StudioSelectField from "../StudioSelectField.vue";
import { computed, inject, onBeforeUnmount, onMounted, ref, type Ref } from "vue";
import type { StorageClass } from "@/services/storage/storage";
import { ProjectID } from "../../constant/constant";
import { SCENE_FILE, createSceneProject, decodeSceneProject, type SceneMainArea } from "../SceneEditor/sceneProject";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestMainAreaSelect',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const storage = inject<StorageClass>("storage")!;
const workspace = inject<Ref<string>>("selectedWorkspaceId")!.value;
const file = `/${workspace}/${SCENE_FILE}`;
const mainAreas = ref<SceneMainArea[]>([]);
const busy = ref(false);
const error = ref("");
let disposed = false;
const options = computed(() => {
  const valid = mainAreas.value.filter(area => /^[+-]?\d+$/.test(area.id.trim())
    && Number(area.id) >= -2147483648 && Number(area.id) <= 2147483647);
  const counts = new Map<number, number>();
  for (const area of valid) counts.set(Number(area.id), (counts.get(Number(area.id)) ?? 0) + 1);
  return valid.filter(area => counts.get(Number(area.id)) === 1)
    .map(area => ({ id: Number(area.id), name: area.name || "未命名一级区域" }));
});
const currentExists = computed(() => options.value.some(area => area.id === props.modelValue));
const hasInvalidAreas = computed(() => options.value.length !== mainAreas.value.length);

async function load() {
  if (busy.value || disposed) return;
  busy.value = true;
  error.value = "";
  try {
    const exists = await storage.setProject(ProjectID).exists(file);
    if (disposed) return;
    // 与场景编辑器首次打开时使用相同默认数据；此处只读，不创建或覆盖场景文件。
    const scene = exists ? decodeSceneProject(await storage.setProject(ProjectID).readFile(file)) : createSceneProject();
    if (!disposed) mainAreas.value = scene.mainAreas;
  } catch (reason) {
    if (!disposed) error.value = reason instanceof Error ? reason.message : "无法读取一级区域列表";
  } finally { if (!disposed) busy.value = false; }
}
function selectMainArea(event: Event) {
  const value = Number((event.target as HTMLSelectElement).value);
  if (!busy.value && !error.value && options.value.some(area => area.id === value)) emit("update:modelValue", value);
}
onMounted(load);
onBeforeUnmount(() => { disposed = true; });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StudioSelectField, {
        value: __props.modelValue,
        "aria-label": "所属一级区域",
        disabled: busy.value || Boolean(error.value) || !options.value.length,
        onChange: selectMainArea
      }, {
        default: _withCtx(() => [
          (!currentExists.value)
            ? (_openBlock(), _createElementBlock("option", {
                key: 0,
                value: __props.modelValue,
                disabled: ""
              }, _toDisplayString(busy.value ? '正在读取一级区域' : error.value ? '当前一级区域' : '未匹配一级区域') + " · #" + _toDisplayString(__props.modelValue), 9, _hoisted_3))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (area) => {
            return (_openBlock(), _createElementBlock("option", {
              key: area.id,
              value: area.id
            }, _toDisplayString(area.name) + " · #" + _toDisplayString(area.id), 9, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "disabled"]),
      _createElementVNode("button", {
        type: "button",
        disabled: busy.value,
        "aria-label": "刷新一级区域列表",
        onClick: load
      }, _toDisplayString(busy.value ? '读取中…' : '刷新'), 9, _hoisted_5)
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(error.value) + "；当前编号已保留，可刷新重试。", 1))
      : (!busy.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!mainAreas.value.length)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, "场景中还没有一级区域，请先在“场景”中创建，再刷新列表。"))
              : (!currentExists.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, "当前编号 #" + _toDisplayString(__props.modelValue) + " 未关联有效一级区域，请选择所属一级区域。", 1))
                : _createCommentVNode("", true),
            (hasInvalidAreas.value)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, "部分一级区域 ID 无效或重复，请在“场景”中修正后刷新。"))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})